import { render, staticRenderFns } from "./NolaNovelNotificationListItem.vue?vue&type=template&id=a7ac2892&scoped=true"
import script from "./NolaNovelNotificationListItem.vue?vue&type=script&lang=ts"
export * from "./NolaNovelNotificationListItem.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelNotificationListItem.vue?vue&type=style&index=0&id=a7ac2892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ac2892",
  null
  
)

export default component.exports